import { ReactionType } from '../firebase/firebase.types';

// Descriptions for reaction types to help users understand their meaning
export const getReactionDescription = (reactionType: ReactionType): string => {
  const descriptions = {
    [ReactionType.NO]: "I don't want to go here",
    [ReactionType.MAYBE]: 'I might be interested in this place',
    [ReactionType.YES]: "I'd like to visit this place",
    [ReactionType.STAR]: 'I really want to go here',
    [ReactionType.MUST_GO]: 'We need to go here',
  };
  return descriptions[reactionType];
};
